import { readMe } from '@directus/sdk';
import { Center, Loader } from '@mantine/core';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

import { auth, directusClient } from '../../services/directusClient/directusClient.ts';
import { signupSocial } from '../../services/promoterAuthentication.ts';

const useSocialLogin = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      // Exchanges the cookie Google or Facebook login left behind for the promotor login.
      await auth.refresh();

      const loggedInUser = await directusClient.request(readMe());

      if (!loggedInUser) {
        void navigate('/dashboard');
        return;
      }

      if (loggedInUser.promoter) {
        void navigate('/dashboard');
        return;
      }

      const result = await signupSocial();

      if ('success' in result && result.success) {
        void navigate('/dashboard');
      }
    },
  });
};

export const SocialLogin: FC = () => {
  const processed = useRef<boolean>(false);
  const { mutate, isPending } = useSocialLogin();

  useEffect(() => {
    if (processed.current || isPending) {
      return;
    }

    mutate(undefined, {
      onSettled: () => {
        processed.current = true;
      },
    });
  }, [isPending, mutate]);

  return <Center>{isPending && <Loader />}</Center>;
};
